import { useState } from 'react';

/**
 * Hook for managing step navigation
 * @param max - Maximum step number
 * @param min - Minimum step number (default: 0)
 * @param start - Initial step to start at (default: min). Allows starting at any step between min and max,
 *                while still allowing jump() to navigate to any step including steps before the initial one.
 */
const useSteps = (max: number, min = 0, start?: number) => {
  // If start is not provided, default to min (backward compatible)
  const initialStep =
    start !== undefined ? Math.min(Math.max(start, min), max) : min;

  const [step, setStep] = useState(initialStep);
  return {
    step,
    isLast: step === max,
    isFirst: step === min,
    isOneStep: max === min,
    next: () => setStep((n) => Math.min(n + 1, max)),
    back: () => setStep((n) => Math.max(n - 1, min)),
    jump: (n: number) => setStep(Math.min(Math.max(n, min), max)),
  };
};

export default useSteps;
